import React, { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import SwitchInput from "./reusable-modules/switch-input";
import { toast } from "react-toastify";
import ai from "../helpers/axios";

const DutyToggle = ({ noMargin }) => {
  const { user, getAccessTokenSilently, loginWithRedirect } = useAuth0();

  const userRoles = user && user["https://new.evojets.com/roles"];

  const isSuperAdmin = userRoles.some(function (role) {
    return "Super Admin" === role;
  });
  const isDutyAdmin = user && user["https://new.evojets.com/appMetadata"]?.isDutyAdmin;

  const isDutySales = user && user["https://new.evojets.com/appMetadata"]?.isDutySales;
  const isOnDuty = user && user["https://new.evojets.com/appMetadata"]?.isOnDuty;

  const handleToggle = useCallback(async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const data = {
      isOnDuty: e.target.checked,
    };

    if (!isOnDuty && !isDutyAdmin && !isSuperAdmin) {
      return;
    }

    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    try {
      const response = await ai
        .auth(token)
        .post(`/api/users/updateMyIsOnDuty`, data)

      if (response?.data) {
        await getAccessTokenSilently({
          ignoreCache: true,
        });
        toast.success("Duty Status Successfully!");
      }
    } catch (error) {
      return toast.error("There must be at least one user on duty.");
    }
  }, [getAccessTokenSilently, loginWithRedirect, isDutyAdmin, isSuperAdmin, isOnDuty]);

  if (!isDutySales) {
    return null;
  }

  return (
    <div className={`navbar-nav${noMargin ? ' m-0' : ''}`}>
      <SwitchInput
        checked={isOnDuty}
        onChange={handleToggle}
        leftLabel={
          <>
            {isOnDuty ? <span className="label-green">On Duty</span> : null}
          </>
        }
        rightLabel={
          <>
            {!isOnDuty ? <span className="label-red">Off Duty</span> : null}
          </>
        }
        containerClasses="duty-switch-container"
        disabled={!isOnDuty && !isDutyAdmin && !isSuperAdmin}
      />
    </div>
  );
};

export default DutyToggle;
